export class ModalDialog {
    constructor(selector) {
        this.$modalDialogContainer = $(selector);
        this.$currentModal = null;
    }

    init() {
        $(".modal-dialog-link").on('click', (e) => this.modalDialogClick(e));
    }

    modalDialogClick(e) {
        let $button = $(e.currentTarget);
        let url = $button.data("modal-dialog-url");
        this.getAndLoadDiv(url, ".modal");
        e.preventDefault();
    }

    getAndLoadDiv(url, divSelector) {
        $.get(url, (data) => {
            this.$modalDialogContainer.html(data);
            this.$currentModal = this.$modalDialogContainer.find(divSelector);
            this.$currentModal.modal('show');
            let forms = this.$modalDialogContainer.find("form");
            if (forms.length > 0)
                $.validator.unobtrusive.parse(forms[0]);
        });
    }
}


// WEBPACK FOOTER //
// ./frontend/js/components/ost.modal-dialog.js